import { App, Input, Modal } from 'antd';
import React, { useState } from 'react';
import { sendFeedback } from '../api/auth';
import { useTranslation } from 'react-i18next';

const { TextArea } = Input;

interface FeedbackModalProps {
    visible: boolean;
    onClose: () => void;
}

const FeedbackModal: React.FC<FeedbackModalProps> = ({ visible, onClose }) => {
    const { message } = App.useApp();
    const [subject, setSubject] = useState('');
    const [messageText, setMessageText] = useState('');
    const [loading, setLoading] = useState(false);
    const { t } = useTranslation('common');

    const handleSubmit = async () => {
        if (!subject.trim() || !messageText.trim()) {
            message.error(t('feedback.empty_error'));
            return;
        }

        setLoading(true);
        try {
            const response = await sendFeedback({ subject, message: messageText });

            if (response?.ok) {
                message.success(t('feedback.success'));
                handleClose();
            } else {
                message.error(response?.message || t('feedback.error'));
            }
        } catch (error) {
            message.error(t('feedback.error'));
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        setSubject('');
        setMessageText('');
        onClose();
    };


    return (
        <Modal
            title={t('feedback.title')}
            open={visible}
            onOk={handleSubmit}
            onCancel={handleClose}
            confirmLoading={loading}
            closable={false}
            width={600}
            okText={t('feedback.send')}
            cancelText={t('feedback.cancel')}
            destroyOnHidden
        >
            <div className="space-y-4">
                <div>
                    <p className='mb-2'>
                        {t('feedback.contact_prefix')} <a className='underline' href={"https://www.aitomistic.com/en/contact"}>{t('feedback.contact_here')}</a>.
                    </p>
                    <Input
                        value={subject}
                        onChange={(e) => setSubject(e.target.value)}
                        placeholder={t('feedback.subject_placeholder', 'Subject')}
                        className="w-full mb-4"
                        maxLength={200}
                    />
                    <TextArea
                        value={messageText}
                        onChange={(e) => setMessageText(e.target.value)}
                        placeholder={t('feedback.placeholder')}
                        rows={6}
                        className="w-full mb-4"
                        maxLength={2000}
                        showCount
                    />
                </div>
            </div>
        </Modal>
    );
};

export default FeedbackModal;
